const agent = {
  path: 'agent/:area_id/:level/:assistant',
  component: () => import("@/views/member/agent/agent"),
  meta: {
    tabBar: 'office'
  },
  children: [{
      //历史
      path: 'history',
      component: () => import("@/views/member/agent/history"), //历史收益
      meta: {
        tabBar: 'office'
      },
      children: [{
        //历史明细
        path: 'history-income',
        component: () => import("@/views/member/agent/history-income"),
        meta: {
          tabBar: 'office'
        },
      }]
    }, {
      //商城收益
      path: 'shop-income/:assistant',
      component: () => import("@/views/member/agent/shop-income"),
      meta: {
        tabBar: 'office'
      },
      children: [{
        //商城收益详情
        path: 'shop-income-detail',
        component: () => import("@/views/member/agent/shop-income-detail"),
        meta: {
          tabBar: 'office'
        }
      }, {
        //角色招募
        path: 'role-detail',
        component: () => import("@/views/member/agent/role-detail"),
        meta: {
          tabBar: 'office'
        }
      }, {
        //关联产品明细
        path: 'relevance-product',
        component: () => import("@/views/member/agent/relevance-product"),
        meta: {
          tabBar: 'office'
        }
      }, {
        //关联产品收益统计明细
        path: 'income-statistics',
        component: () => import("@/views/member/agent/income-statistics"),
        meta: {
          tabBar: 'office',
          keepAlive: false
        }
      }],
    }, {
    //数据统计
      path: 'data-info',
      component: () => import("@/views/member/agent/data-info"),
      meta: {
        tabBar: 'office'
      }
    },{
    //店长推荐销售数据列表
      path: 'data-list',
      component: () => import("@/views/member/agent/data-list"),
      meta: {
        tabBar: 'office'
      }
     },{
      //店长推荐销售数据
      path: 'sell-data',
      component: () => import("@/views/member/agent/sell-data"),
      meta: {
        tabBar: 'office'
      }
    },{
      //销售统计解读
      path: 'sell-explain',
      component: () => import("@/views/member/agent/sell-explain"),
      meta: {
        tabBar: 'office'
      }
    },{
      //商城收益
      path: 'wait-settle',
      component: () => import("@/views/member/agent/wait-settle"),
      meta: {
        tabBar: 'office'
      }
    },
    {
      //赠品管理
      path: 'gift-manage',
      component: () => import("@/views/member/agent/gift-manage"),
      meta: {
        tabBar: false
      }
    },
    {
      //赠品明细
      path: 'gift-detail',
      component: () => import("@/views/member/agent/gift-detail"),
      meta: {
        tabBar: false
      }
    }, {
      //申请退出
      path: 'quit',
      component: () => import("@/views/member/agent/quit"),
      meta: {
        tabBar: 'office'
      }
    }, {
      //代理经费
      path: 'operating-expenses',
      component: () => import("@/views/member/agent/operating-expenses"),
      meta: {
        tabBar: 'office'
      },
      children: [{
        //代理经费
        path: 'operating-expenses-detail',
        component: () => import("@/views/member/agent/operating-expenses-detail"),
        meta: {
          tabBar: 'office'
        }
      }]
    }, {
      //团队管理
      path: 'team',
      component: () => import("@/views/member/agent/team"),
      meta: {
        tabBar: 'office',
        title: "团队管理"
      }
    }
  ]
};

export default agent;